import * as React from 'react'
import { FC, ReactNode } from 'react'
import { useFieldArray, useFormContext } from 'react-hook-form'
import Field from '@templates/Field'
import DeleteButton from '@templates/DeleteButton'
import AddButton from '@organisms/AddButton'
import { FieldForRender } from '@templates/AddNewItemModal'
import { Option } from '@organisms/Select'
import {
  AddButtonWrapper,
  Container,
  DeleteButtonWrapper,
  StyledFlexWrapper,
} from './styled'

type Props = {
  fieldsName: string
  fieldsSrc?: FieldForRender[]
  amendValue: any
  addLabel?: string
  isDisabled?: boolean
  addButtonId?: string
  fieldId?: string
  contentBefore?: ReactNode
  contentAfter?: ReactNode
  FieldsSrcRender?: FC<{ index: number }>
}

const MultilineFieldNew: FC<Props> = ({
  fieldsName,
  fieldsSrc,
  FieldsSrcRender,
  amendValue,
  addLabel = 'Добавить',
  isDisabled = false,
  addButtonId = 'add-button-multiline',
  fieldId,
  contentBefore,
  contentAfter,
}) => {
  const methods = useFormContext()
  const { control, getValues } = methods

  const { fields, append, remove } = useFieldArray({
    name: fieldsName,
    control,
  })

  const selectedMultilineValues =
    (getValues()[fieldsName] as Option[])?.map((option) => option?.value) || []

  return (
    <Container id={fieldId}>
      {contentBefore}
      {fields.map((field, index) => {
        return (
          <div key={field.id}>
            <StyledFlexWrapper>
              {FieldsSrcRender ? (
                <FieldsSrcRender index={index} />
              ) : (
                fieldsSrc?.map((item) => (
                  <Field
                    key={item.name}
                    {...item}
                    componentProps={{
                      ...item.componentProps,
                      selectedMultilineValues,
                    }}
                    name={
                      fieldsSrc.length === 1
                        ? `${fieldsName}.${index}`
                        : `${fieldsName}.${index}.${item.name}`
                    }
                  />
                ))
              )}
              <DeleteButtonWrapper>
                <DeleteButton
                  type="button"
                  onClick={() => remove(index)}
                  disabled={isDisabled}
                />
              </DeleteButtonWrapper>
            </StyledFlexWrapper>
          </div>
        )
      })}

      <AddButtonWrapper>
        <AddButton
          id={addButtonId}
          type="button"
          onClick={() => append(amendValue)}
          disabled={isDisabled}
        >
          {addLabel}
        </AddButton>
      </AddButtonWrapper>
      {contentAfter}
    </Container>
  )
}

export default MultilineFieldNew
